export default "__VITE_ASSET__DLHb3wNe__"